import { IDataExperience } from "../types/dataExperience.type";

export const dataExperience: IDataExperience[] = [
  {
    id: 6,
    Position: "Frontend Engineer",
    Company: "Synapsis",
    StartDate: "Mar 2025",
    EndDate: "Mar 2026",
    JobDescription: `Developed and enhanced core frontend features for a 
    Learning Management System (LMS), supporting scalable learning workflows and 
    role-based user access. Built interactive UI components and data visualizations for a 
    Driver Monitoring System (DMS) to support real-time operational monitoring and 
    decision-making. Contributed to building a Frontend Design System by creating reusable
    components and standardizing UI patterns. Developed and maintained a Windows desktop
    application using Electron for cross-platform deployment. Collaborated closely with 
    backend, QA, product, and design teams to ensure quality delivery across multiple
    projects.`,
  },
  {
    id: 5,
    Position: "Frontend Developer",
    Company: "Telkom Indonesia",
    StartDate: "Feb 2023",
    EndDate: "Mar 2025",
    JobDescription: `Developed real-time EMS and OEE dashboards using React and TypeScript
    to support industrial IoT monitoring and data visualization. Implemented frontend
    unit testing with Jest and React Testing Library to improve application stability and
    reduce regression issues. Optimized UI performance and state management to improve 
    responsiveness and maintainability of the dashboard. Collaborated closely with Backend,
    QA, and Design teams using agile methodology to deliver features efficiently and
    maintain product quality. Built reusable UI components with Ant Design and TailwindCSS
    to ensure consistent UI and faster development.`,
  },
  {
    id: 4,
    Position: "Frontend Developer",
    Company: "Evomo",
    StartDate: "Feb 2022",
    EndDate: "Jan 2023",
    JobDescription: `Developed landing page and device order management features, improving
    usability and operational workflow. Integrated frontend with backend APIs and payment
    flow to enable end-to-end user transactions. Refactored UI components and standardized
    styling using Ant Design and TailwindCSS to improve maintainability and consistency. 
    Collaborated closely with backend engineers and stakeholders to align technical 
    delivery with product requirements. Assisted backend development by building REST APIs
    using Node.js, Express.js, and MongoDB.`,
  },
  {
    id: 3,
    Position: "Frontend Engineer (Freelance)",
    Company: "DOT Indonesia",
    StartDate: "Jun 2022",
    EndDate: "May 2023",
    JobDescription: `Developed and maintained the NFT Infinity web application using 
    Next.js and TypeScript, including feature enhancements and bug fixing for production
    stability. Implemented Web3 integration for wallet connection and transaction flow to 
    support NFT functionality. Built a Document Generator web application for Pertamina, 
    supporting file upload and document processing workflow. Performed bug fixing and 
    feature updates on the Flip landing page to maintain UI quality and compatibility. 
    Collaborated closely with Backend Engineers and QA to deliver and maintain multiple 
    client projects.`,
  },
  {
    id: 2,
    Position: "Frontend Developer (Intern)",
    Company: "Kawan Kerja",
    StartDate: "Feb 2022",
    EndDate: "Apr 2022",
    JobDescription: `Developed a company profile website using React.js, TypeScript, 
    and Styled-Components. Improved understanding of component-based architecture,
    API integration, and clean UI structure.`,
  },
  {
    id: 1,
    Position: "Frontend Engineer (Intern)",
    Company: "Endorsaja",
    StartDate: "Nov 2021",
    EndDate: "Jan 2022",
    JobDescription: `Assisted in developing and maintaining web application features using
    React.js. Collaborated with the Backend team to integrate the Frontend with REST APIs.
    Performed UI improvements and bug fixing to support production stability. Built a web
    admin back office interface for internal operational use.`,
  },
];
